<template>
  <div class="template">
    <!-- 搜索区域 -->
    <div class="search">
      <div class="search-center">
        <!-- 用户ID搜索 -->
        <div class="search-item">
          <Input clearable
                 v-model="search.userId"
                 placeholder="用户ID"
                 @on-enter="searchFn"
                 style="width: 150px;"
          ></Input>
        </div>
        <!-- 昵称搜索 -->
        <div class="search-item">
          <Input clearable
                 v-model="search.nickname"
                 placeholder="昵称"
                 @on-enter="searchFn"
                 style="width: 150px;"
          ></Input>
        </div>
        <div class="search-item">
          <Input clearable
                 v-model="search.street"
                 placeholder="街道"
                 @on-enter="searchFn"
                 style="width: 150px;"
          ></Input>
        </div>
        <!-- 时间范围搜索 -->
        <div class="search-item">
          <DatePicker
              type="daterange"
              placement="bottom-end"
              placeholder="选择日期范围"
              style="width: 200px"
              v-model="search.dateRange"
          ></DatePicker>
        </div>
        <!-- 查询按钮 -->
        <Button
            style="width: 80px;margin-right: 10px;margin-bottom:5px"
            type="primary"
            icon="ios-search"
            @click="searchFn"
        >查询
        </Button>
      </div>
    </div>

    <!-- 表格区域 -->
    <Table
        :columns="diyData.columns"
        :data="apiData.tableList"
    >
      <!-- 分页器 -->
      <template slot="footer">
        <Page
            :total="apiData.total"
            show-total
            :page-size="search.pageSize"
            :current="search.pageNo"
            @on-change="pageChange"
            @on-page-size-change="pageSizeChange"
            class-name="footer-page"
            show-elevator
            show-sizer
        ></Page>
      </template>
    </Table>
  </div>
</template>

<script>
import {apiUserlogList} from "@/api/userlog";

export default {
  name: 'UserLog',
  data() {
    return {
      // 路由查询参数
      query: {},
      // 搜索条件对象
      search: {
        userId: '',         // 用户ID
        nickname: '',       // 昵称
        street: '',
        dateRange: [],      // 日期范围
        pageNo: 1,          // 当前页码
        pageSize: 10,       // 每页条数
      },
      // 表格配置数据
      diyData: {
        columns: [
          // 昵称列
          {
            title: '昵称-id',
            width: '120px',
            render: (h, params) => {
              return h('div', [
                h(
                    'a', // 改为 a 标签
                    {
                      style: {
                        color: '#2D8cF0',
                        cursor: 'pointer'
                      },
                      on: {
                        click: () => {
                          this.handleClickReferrerId(params.row.userId) // 绑定点击事件
                        }
                      }
                    },
                    params.row.nickname + "-" + params.row.userId
                )
              ])
            }
          },
          {
            title: '街道地址',
            width: '150px',
            key: 'street',
          },
          // 成功次数列
          {
            title: '成功',
            width: '80px',
            key: 'successNum',
          },
          {
            title: '失败',
            width: '80px',
            key: 'failedNum',
          },
          // 失败原因列
          {
            title: '失败原因',
            width: '150px',
            key: 'failedReason',
          },
          // 问题列
          {
            title: '问题',
            width: '150px',
            key: 'question',
          },
          // 需求列
          {
            title: '需求',
            width: '150px',
            key: 'demand',
          },
          // 记录日期列
          {
            title: '记录日期',
            width: '120px',
            key: 'recordDate',
          },
          {
            title: '上班时间',
            width: '160px',
            render: (h, params) => {
              var html = [
                h('span', params.row.beginTime + "~" + params.row.endTime)
              ]
              return html
            }
          },
          // 创建时间列
          {
            title: '创建时间',
            width: '170px',
            key: 'createTime',
          }
        ]
      },
      // API数据
      apiData: {
        total: 0,        // 总条数
        tableList: [],   // 表格数据
      },
      loading: false
    }
  },
  methods: {
    // 页码改变处理
    pageChange(e) {
      this.search.pageNo = e
      this.getTableList()
    },
    // 每页条数改变处理
    pageSizeChange(e) {
      this.search.pageSize = e
      this.search.pageNo = 1
      this.getTableList()
    },
    // 搜索处理
    searchFn() {
      this.search.pageNo = 1
      this.getTableList()
    },
    handleClickReferrerId(userId) {
      this.search.userId = userId // 设置推荐人 ID 为搜索条件
      this.search.pageNo = 1 // 重置页码为第一页
      this.getTableList() // 调用查询方法
    },
    // 获取表格数据
    getTableList() {
      this.loading = true
      var opt = {...this.search, ...this.query}

      // 处理日期范围参数
      if (this.search.dateRange && this.search.dateRange.length === 2) {
        opt.dateStart = this.formatDate(this.search.dateRange[0])
        opt.dateEnd = this.formatDate(this.search.dateRange[1])
      }
      delete opt.dateRange

      apiUserlogList(opt).then((res) => {
        const {
          list,
          totalCount
        } = res.data

        this.apiData.tableList = list
        this.apiData.total = totalCount
      }).finally(() => this.$store.commit('setSpinShow', false))
    },
    // 格式化日期
    formatDate(date) {
      if (!date) return ''
      return new Date(date).toISOString().split('T')[0]
    }
  },
  // 组件挂载时执行
  mounted() {
    this.query = this.$route.query
    this.getTableList()
  },
}
</script>

<style scoped lang="less">
.template {
  width: 100%;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
}

.button-border {
  margin-right: 10px;
}
</style>
